import { render, staticRenderFns } from "./PersonData.vue?vue&type=template&id=3bb84f3a"
import script from "./PersonData.vue?vue&type=script&lang=js"
export * from "./PersonData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports